// extracted by mini-css-extract-plugin
module.exports = {"link":"links_link__endQu"};